import { DELETE_COMPANY_PAYMENT_DEADLINE } from "queries/neoFact/settings";
import TooltipButton from "views/Documents/components/TooltipButton";
import { MdDelete } from "react-icons/md";
import { FaExclamationCircle } from "react-icons/fa";
import { clientNeoFact } from "@neonumy/api-clients";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";
import { Modal, notification } from "antd";

interface DeleteFormPropsType {
  id: ID;
  refetch: () => void;
}

export default function DeleteButton({ id, refetch }: DeleteFormPropsType) {
  const { t } = useTranslation();

  const [deletePaymentDeadline] = useMutation<
    DeleteCompanyPaymentDeadlineResponse,
    DeleteCompanyPaymentDeadlineVars
  >(DELETE_COMPANY_PAYMENT_DEADLINE, {
    client: clientNeoFact,
  });

  const onOk = async () => {
    const response = await deletePaymentDeadline({ variables: { id } });

    if (response?.data?.deleteCompanyPaymentDeadline?.success) {
      notification.success({
        message: t("Payment date limit"),
        description: t("Deleted Successfully"),
        placement: "bottomLeft",
      });
    } else {
      notification.error({
        message: t("Payment date limit"),
        description: t("Something went wrong on deleting"),
        placement: "bottomLeft",
      });
    }

    refetch();
  };

  const confirm = () => {
    Modal.confirm({
      title: t("Confirm"),
      icon: (
        <span className="anticon">
          <FaExclamationCircle />
        </span>
      ),
      content: t("Are you sure, that you want to delete?"),
      okText: t("Yes"),
      cancelText: t("No"),
      onOk: onOk,
    });
  };
  return (
    <TooltipButton variant="delete" placement="top" handleOnClick={confirm} icon={<MdDelete />} />
  );
}
